import { sumBy } from 'lodash'
import accounting from 'accounting'

export default {
  computed: {
    /**
     * Get the job size.
     *
     * @return float
     */
    jobSize () {
      return accounting.formatNumber(this.job.quantity, 2)
    },

    /**
     * Get the planned load size.
     *
     * @return float
     */
    loadSize () {
      return accounting.formatNumber(sumBy(this.loads, load => {
        if (load.status === 'cancelled') {
          return 0
        }

        if (load.weighbridge === null || load.weighbridge.status !== 'approved') {
          return parseFloat(load.size) || 0
        }

        return load.weighbridge.total_tonnage
      }), 2)
    },

    /**
     * Get the planned load percentage of the total job quantity.
     *
     * @return float
     */
    loadPercentage () {
      if (this.job.quantity === 0 || this.job.quantity === null) {
        return 0
      }

      return Math.round((this.loadSize / this.job.quantity) * 100)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loads/assigned-tonnage-helpers.js